import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ 
  selectedCount, 
  totalCount,
  onSelectAll,
  onDeselectAll,
  onBulkDelete,
  onBulkDownloadToggle,
  onBulkExport 
}) => {
  const isAllSelected = selectedCount === totalCount;

  return (
    <div className="bg-card border border-border rounded-xl p-3 md:p-4 shadow-warm-md">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <button
            onClick={isAllSelected ? onDeselectAll : onSelectAll}
            className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-all ${
              isAllSelected 
                ? 'bg-primary border-primary' 
                : selectedCount > 0
                ? 'bg-primary/50 border-primary' :'border-border hover:border-primary'
            }`}
          >
            {isAllSelected && <Icon name="Check" size={16} color="white" />}
            {selectedCount > 0 && !isAllSelected && <Icon name="Minus" size={16} color="white" />}
          </button>
          
          <div>
            <p className="text-sm font-medium">
              {selectedCount} of {totalCount} selected
            </p>
            <p className="text-xs text-muted-foreground">
              {isAllSelected ? 'All items selected' : 'Select items to perform bulk actions'}
            </p>
          </div>
        </div>

        {selectedCount > 0 && (
          <div className="flex flex-wrap gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              iconName="Lock"
              iconPosition="left"
              onClick={onBulkDownloadToggle}
              className="flex-1 sm:flex-none"
            >
              Toggle Lock
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={onBulkExport}
              className="flex-1 sm:flex-none"
            >
              Export
            </Button>
            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={onBulkDelete}
              className="flex-1 sm:flex-none"
            >
              Delete
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkActionsBar;